// extracted by mini-css-extract-plugin
export var productImage = "_p4-1";
export var viewLink = "_p4-2";
export var wishlistItem = "_p4-0";